module.exports = __webpack_public_path__ + "img/cafeteria.d825d612.jpg";